<template>
	<div>
		<div class="select">
			<div class="selectBox">
				<h5>排序</h5>
				<el-select v-model="form.condition.priceOrder" placeholder="请选择">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>关键字搜索</h5>
				<van-field v-model="form.condition.content" placeholder="请输入商品关键字" />
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>不含关键字</h5>
				<van-field v-model="form.condition.exclude_keyword" placeholder="请输入不包含的关键字" />
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>商品分类</h5>
				<el-select v-model="categoryId" placeholder="请选择">
					<el-option v-for="item in typeList" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="categoryIdSecond" placeholder="请选择" value-key="id">
					<el-option v-for="item in list" :key="item.id" :label="item.title" :value="item">
					</el-option>
				</el-select>
				<div v-if="form.condition.categoryId1" class="condition top20">
					<span @click="clickCategoryId(item.id)" :class="{active:form.condition.categoryId==item.id}" v-for="(item, index) in categoryIdSecond.children" :key="index">{{item.title}}</span>
				</div>
			</div>
			<div class="selectBox" v-if="false">
				<p class="line"></p>
				<h5>商品品牌</h5>
				{{ brands }}
				<!-- <van-field v-model="form.condition.brand" placeholder="请输入商品品牌" /> -->
				<!-- <el-select v-model="form.condition.brand" placeholder="请选择">
					<el-option v-for="item in brands" :key="item.id" :label="item.title" :value="item.id">
					</el-option>
				</el-select> -->
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>指定大小</h5>
				<el-select v-model="sizeGroup" placeholder="请选择">
					<el-option
						v-for="(item,index) in groups"
						:key="index"
						:label="item"
						:value="index"
					>
					</el-option>
				</el-select>
				<el-select v-model="form.condition.size_id" placeholder="请选择" v-if="sizeGroup">
					<el-option
						v-for="(item) in sizeList[sizeGroup]"
						:key="item.id"
						:label="item.name"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>指定价格</h5>
				<input class="input" v-model="form.condition.minPrice" type="text" placeholder="最低价" />
				<span>-</span>
				<input class="input" v-model="form.condition.maxPrice" type="text" placeholder="最高价" />
				<span>日元</span>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>商品状况</h5>
				<div class="condition">
				<span @click="clickCondition(item.id)" :class="{active:form.condition.item_condition_id==item.id}" v-for="(item,index) in goodsCondition" :key="index">{{item.name}}</span>
				</div>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>运费</h5>
				<div class="condition">
				<span @click="clickConditionFreight(item.id)" :class="{active:form.condition.shipping_payer_id==item.id}" v-for="(item,index) in freightList" :key="'freight' + index">{{item.name}}</span>
				</div>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>颜色</h5>
				<div class="condition">
				<span @click="clickConditionColor(item.id)" :style="'background-color:' + item.rgb" :class="{active:form.condition.color_id==item.id}" v-for="(item,index) in colorList" :key="'color' + index">{{item.name}}</span>
				</div>
			</div>
			<div class="selectBox">
				<p class="line"></p>
				<h5>出售状态</h5>
				<el-select v-model="form.condition.status" placeholder="请选择">
					<!-- <el-option :label="全部" :value="-1"></el-option> -->
					<el-option label="在售" value="STATUS_ON_SALE">
					</el-option>
					<el-option label="售完" value="STATUS_SOLD_OUT">
					</el-option>
					<el-option label="出售中" value="STATUS_TRADING">
					</el-option>
				</el-select>
			</div>
			<div class="btns">
				<span @click="reset">重置</span>
				<span @click="clickSub">确定</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "",
		props: ["conditionList", "keyword"],
		data() {
			return {
				show: true,
				condition: '11',
				options: [{
						value: "",
						label: "默认",
					},
					{
						value: "up",
						label: "价格从低到高",
					},
					{
						value: "down",
						label: "价格从高到低",
					},
				],
				optionsVant: [
					{
						text: "默认",
						value: "",
					},
					{
						text: "价格从低到高",
						value: "up",
					},
					{
						text: "价格从高到低",
						value: "down",
					},
				],
				value: "",
				form: {
					page: 1,
					lastId: 0,
					condition: {
						priceOrder: undefined,
						status: 'STATUS_ON_SALE',
						condition: '',
						brand: '',
						content: this.keyword,
						minPrice: undefined,
						maxPrice: undefined,
						categoryId: undefined,
						color_id: undefined,
						shipping_payer_id: undefined,
						size_id: undefined,
						item_condition_id: undefined,
						exclude_keyword: undefined,
						categoryId0: undefined,
						categoryId1: undefined
					},
				},

				typeList: [],
				categoryId: undefined,
				list: [],
				categoryIdSecond: undefined,
				colorList: [],
				sizeList: [],
				sizeListFirst: [],
				sizeListSecond: [],
				goodsCondition: [],
				freightList: [],
				groups: [],
				sizeGroup: undefined,
			};
		},
		computed: {},
		watch: {
			categoryId(val) {
				this.form.condition.categoryId0 = val
				this.getList(val)
			},
			categoryIdSecond(val) {
				this.form.condition.categoryId1 = val.id
			}
		},
		created() {

		},
		mounted() {
			this.getBase()
			this.getColorList()
			this.getSizeList()
			this.getGoodsCondition()
			this.getFreightList()
		},
		methods: {
			// 分类
			clickCondition(item) {
				if(this.form.condition.item_condition_id == item) {
					this.form.condition.item_condition_id = undefined
				}else{
					this.form.condition.item_condition_id = item
				}
			},
			clickConditionColor(item) {
				if(this.form.condition.color_id == item) {
					this.form.condition.color_id = undefined
				}else{
					this.form.condition.color_id = item
				}
			},
			clickConditionFreight(item) {
				if(this.form.condition.freight_id == item) {
					this.form.condition.freight_id = undefined
				}else{
					this.form.condition.freight_id = item
				}
			},
			clickCategoryId(id) {
				// this.condition.categoryId = id
				this.$set(this.form.condition, "categoryId", id)
			},
			//查询一级分类
			getBase() {
				// this.form.condition.content = this.props.keyword;
				this.$post({
					url: "/portal/Shop",
					module: "GoodsCategory",
					interface: "1001",
					data: {},
				}).then((res) => {
					console.log(res, 1);
					this.typeList = res.list;
					// if (res.list.length) {
					//   this.changeType(res.list[0]);
					// }
				});
			},
			//查询二三级分类
			getList(id) {
				this.$post({
					url: "/portal/Shop",
					module: "GoodsCategory",
					interface: "1003",
					data: {
						parentId: id,
					},
				}).then((res) => {
					// console.log(res);
					this.list = res.list;
				});
			},
			getColorList() {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "4001",
					data: {
					},
				}).then((res) => {
					console.log(res);
					this.colorList = res.colorList;
				});
			},
			getSizeList() {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "4002",
					data: {
					},
				}).then((res) => {
					console.log(res);
					const groupedSizes = {};
					const groups = {};
					const sizeList = res.sizeList;

					sizeList.forEach(size => {
						const groupId = size.groupId;
						if (!groupedSizes[groupId]) {
							groupedSizes[groupId] = [];
						}
						groupedSizes[groupId].push(size);
						groups[groupId] = size.group;
					});
					console.log(groupedSizes)
					console.log(groups)
					this.sizeList = groupedSizes;
					this.groups = groups;
				});
			},
			getGoodsCondition() {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "4003",
					data: {
					},
				}).then((res) => {
					console.log(res);
					this.goodsCondition = res.conditionList;
				});
			},
			getFreightList() {
				this.$post({
					url: "/portal/Shop",
					module: "Goods",
					interface: "4004",
					data: {
					},
				}).then((res) => {
					console.log(res);
					this.freightList = res.freightList;
				});
			},
			// 提交筛选
			clickSub() {
				console.log(this.form, 1)
				this.$emit("newSearch", this.form)
			},
			// 重置
			reset() {
				this.form.condition.priceOrder = undefined
				this.form.condition.status = "STATUS_ON_SALE"
				this.form.condition.condition = undefined
				this.form.condition.brand = undefined
				this.form.condition.content = undefined
				this.form.condition.minPrice = undefined
				this.form.condition.maxPrice = undefined
				this.form.condition.categoryId = undefined
				this.form.condition.color_id = undefined
				this.form.condition.shipping_payer_id = undefined
				this.form.condition.size_id = undefined
				this.form.condition.item_condition_id = undefined
				this.form.condition.exclude_keyword = undefined
			    this.form.condition.categoryId0 = undefined
				this.form.condition.categoryId1 = undefined

			}
		},
	};
</script>

<style lang='less' scoped>
	/deep/ .van-field__control {
		height: 32px;
		background: #f1f2f3;
		border-radius: 16px;
		width: 80%;
		padding-left: 20px;
	}

	/deep/ .el-input__inner {
		background: #f1f2f3;
		border-radius: 16px;
		height: 32px;
		margin-left: 10px;
	}

	.line {
		height: 2px;
		background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
		opacity: 0.3;
		margin-bottom: 10px;
	}

	.select {
		width: 283px;
		height: 100%;
		background: #ffffff;
		box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
		border-radius: 40px 0px 0px 0px;
		position: absolute;
		right: 0;
		top: 0;
		overflow: auto;
		padding-top: 10px;
	}

	.selectBox {
		h5 {
			padding-left: 16px;
			height: 50px;
			line-height: 50px;
		}

		span {
			margin: 0 5px;
		}
	}

	.input {
		width: 100px;
		height: 32px;
		background: #f1f2f3;
		border-radius: 16px;
		padding-left: 10px;
		font-size: 14px;
	}

	.top20 {
		margin-top: 20px;
	}

	.condition {
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		span {
			border-radius: 16px;
			border: 1px solid #dee1e6;
			padding: 4px 15px;
			font-size: 14px;
			margin-bottom: 14px;
		}

		.active {
			color: #fd0212;
			border: 1px solid #fd0212;
		}
	}

	.btns {
		height: 36px;
		background: #fd0212;
		border-radius: 100px;
		display: flex;
		margin: 10px;

		span {
			flex: 1;
			text-align: center;
			line-height: 36px;
			color: #ffffff;
		}

		span:nth-child(1) {
			background: #ffc107;
			border-radius: 100px 0px 0px 100px;
		}
	}
</style>
